import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';

export const buyerNeedCheckoutRejectApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/need/bid_declined', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const buyerNeedCheckoutAcceptApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/need/place_order', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const sellerInvCheckoutRejectApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/offer_declined', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const sellerInvCheckoutAcceptApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/place_order', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const buyerInvCheckoutAcceptApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/place_offer', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const checkPromoIsValidApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/newPromoCode/validate_promocode', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      dispatch(hideAppLoader());
      return { error: true, data: ex.response?.data };
    });
};

export const checkoutBuynow = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/checkout/buynow/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const checkoutBuynowView = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/checkout/buynow/info/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const checkoutBuynowCPUView = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/checkout/buynowcpu/info/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const checkoutBidView = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/checkout/bid/info/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const getBuyerNeedCheckoutDataApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/rfp/v2/need/get_bid_details', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const getCheckoutPageDetailsBuyerInvApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/rfp/v2/inventory/get_inv_to_makeoffer', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const getCheckoutPageDetailsSellerInvApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/rfp/v2/inventory/get_offer_details', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const getCheckoutPageDetailsSellerPickupOrderApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/order/pickup/get_tender_checkout_details', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const getCheckoutPageDetailsSellerDelReqOrderApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/order/delivery/get_tender_checkout_details', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const sellerPickupOrderCheckoutAcceptApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/order/v2/pickup_place_order', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const sellerDelReqOrderCheckoutAcceptApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/order/v2/delivery_pricing/place_order', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const checkoutPostLoadBidView = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/checkout/postLoadBid/info/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const checkoutBuynowCPU = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/checkout/buynowcpu/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerNow = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventoryBuyNow/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerNowOnCPU = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventoryBuyNowCpu/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const placeBidPostInventory = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/bid/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const placeBidPostLoad = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/bid/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const handshake = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/handshake/confirm', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const handshakePostLoad = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/handshake/confirm', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      // setTimeout(
      //   () => {

      //   },
      //   5000
      // );
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const handshakeSellerPostLoad = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/handshake/seller/confirm', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

